import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMenu = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.5024 12.145C14.7784 12.1452 15.0024 12.369 15.0024 12.645C15.0023 12.9209 14.7783 13.1448 14.5024 13.145H1.49756C1.22152 13.145 0.997734 12.921 0.997559 12.645C0.997559 12.3689 1.22142 12.145 1.49756 12.145H14.5024ZM14.5024 7.50049C14.7784 7.50073 15.0024 7.72449 15.0024 8.00049C15.0022 8.27628 14.7782 8.50025 14.5024 8.50049H7.99951C7.72351 8.50049 7.49975 8.27643 7.49951 8.00049C7.49951 7.72435 7.72337 7.50049 7.99951 7.50049H14.5024ZM14.5024 2.85498C14.7783 2.8552 15.0022 3.07917 15.0024 3.35498C15.0024 3.63099 14.7784 3.85476 14.5024 3.85498H1.49756C1.22142 3.85498 0.997559 3.63112 0.997559 3.35498C0.997792 3.07904 1.22156 2.85498 1.49756 2.85498H14.5024Z",
		fill: "currentColor"
	})
});
export default SvgMenu;
